import * as types from "../constants";
import {  GetCompanyDataResult } from "../../Interfaces/Interfaces";

export function UpdateCompanyData(CompanyData: GetCompanyDataResult): types.UpdateCompanyData {
    return {
        type: types.UPDATE_COMPANY_DATA,
        payload: CompanyData
    };
}
